import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SecurityContextHolder} from 'src/app/security/context/security-context-holder';
import {NotificationService} from 'src/app/service/notification.service';
import {PlatformService} from 'src/app/service/platform.service';
import { LoadingService } from 'src/app/service/loading.service';
import { ISupportInquiry } from 'src/app/data/notification/support.inquiry.model';
import { WorkflowService } from 'src/app/service/workflow.service';

@Component({
  selector: 'app-support-modal',
  templateUrl: './support-modal.component.html',
  styleUrls: ['./support-modal.component.scss'],
})
export class SupportModalComponent implements OnInit {
  @Input() open: boolean = false;
  @Output() dismiss = new EventEmitter<any>();
  @Input() tenantId!: string;
  supportForm: FormGroup = new FormGroup<any>({});
  loading!: HTMLIonLoadingElement;
  selector!: string;
  constructor(
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private workflowService: WorkflowService,
    private securityContextHolder: SecurityContextHolder,
    private elementRef: ElementRef,
    public platformService: PlatformService,
  ) {
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  ngOnInit() {
    this.supportForm = new FormGroup({
      subject: new FormControl('', [Validators.required]),
      message: new FormControl('', [Validators.required])
    });
  }

  async onSubmit() {
    if (this.supportForm.invalid)
    {
      await this.notificationService.error('Please fill out all the fields');
    }
    else
    {
      this.loading = await this.loadingService.createWithMessage('Sending Inquiry ...');
      await this.loading.present();
      let inquiry: ISupportInquiry = {
        userEmail: this.securityContextHolder.context.principal.email,
        userFullName: this.securityContextHolder.context.principal.firstName + ' ' + this.securityContextHolder.context.principal.lastName,
        subject: this.supportForm.get('subject')?.value,
        message: this.supportForm.get('message')?.value
      };

      this.workflowService.sendSupportInquiry(this.tenantId, inquiry).subscribe({
        next: (data) => {
          this.notificationService.success('Support inquiry has been sent');
          this.supportForm.reset();
          this.loading.dismiss();
          this.onCancel();
        },
        error: (err) => {
          this.loading.dismiss();
          this.notificationService.error('Failed to send support inquiry');
        }
      });
    }
  }

  onCancel() {
    this.dismiss?.emit();
  }
}
